import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import "./BackButton.css";

const BackButton = ({ loading = false, disabled = false, icon = null, label = "Back", onClick, style, className = ''}) => {

  const isDisabled = disabled || loading;

  return (
    <button
    type="button"
      // className={`back-btn ${disabled ? "back-btn--disabled" : ""}`}
      className={`back-btn ${isDisabled ? 'is-disabled' : ''} ${loading ? 'is-loading' : ''} ${className}`}
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
      style={style}
    >
      {/* <FaArrowLeft className="back-btn__icon" /> */}
            {loading ? (
        <span className="app-btn__spinner" />
      ) : (
        <>
      {icon && <span className="app-btn__icon">{icon}</span>}
      {label}
        </>
      )}

    </button>
  );
};

export default BackButton;
